import { SantaButtonModule } from '@alliance/santa/button'
import { SharedTranslationModule } from '@alliance/shared/translation'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { NotFoundPageComponent } from './not-found-page/not-found-page.component'

@NgModule({
  imports: [CommonModule, RouterModule.forChild([{ path: '', component: NotFoundPageComponent }]), SharedTranslationModule, SantaButtonModule],
  declarations: [NotFoundPageComponent],
  exports: [NotFoundPageComponent]
})
export class AtsNavigationFeatureNotFoundPageModule {}
